import {FC} from 'react'

type Props = {
  rfqs: any[]
  quotations: any[]
  invoices: any[]
  rfqCount: number
  quotationCount: number
  invoiceCount: number
  loading: boolean
  onRFQs: () => void
  onQuotations: () => void
  onInvoices: () => void
}

const status = (value: any) => String(value || '—').replace(/_/g, ' ')
const Widget: FC<{title: string; count: number; rows: any[]; loading: boolean; onView: () => void; columns: string[]; values: (row: any) => string[]}> = ({title, count, rows, loading, onView, columns, values}) => (
  <div className='flex flex-col flex-1 bg-white rounded-2xl p-4 border border-slate-200 shadow-sm'>
    <div className='flex items-center justify-between mb-3'>
      <h3 className='text-sm font-bold text-slate-900'>{title} <span className='text-red-500'>{loading ? '…' : count}</span></h3>
      <button onClick={onView} className='text-[11px] text-blue-600 hover:underline'>View all</button>
    </div>
    <div className='overflow-x-auto'>
      <table className='w-full text-left text-[10px] min-w-[300px]'>
        <thead><tr className='text-slate-400 uppercase'>{columns.map((column) => <th key={column} className='pb-2 font-medium'>{column}</th>)}</tr></thead>
        <tbody>
          {loading && <tr><td colSpan={columns.length} className='py-8 text-center text-slate-400'>Loading…</td></tr>}
          {!loading && rows.length === 0 && <tr><td colSpan={columns.length} className='py-8 text-center text-slate-400'>No records</td></tr>}
          {!loading && rows.map((row, index) => <tr key={row.id ?? index} onClick={onView} className='border-t border-slate-50 hover:bg-slate-50 cursor-pointer'>
            {values(row).map((value, columnIndex) => <td key={columnIndex} className='py-2 text-slate-600'>{columnIndex === values(row).length - 1 ? status(value) : value || '—'}</td>)}
          </tr>)}
        </tbody>
      </table>
    </div>
  </div>
)

const ProcurementAdditionalWidgets: FC<Props> = ({rfqs, quotations, invoices, rfqCount, quotationCount, invoiceCount, loading, onRFQs, onQuotations, onInvoices}) => (
  <div className='grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6'>
    <Widget title='RFQs' count={rfqCount} rows={rfqs} loading={loading} onView={onRFQs} columns={['RFQ', 'Requisition', 'Vessel', 'Status']} values={(row) => [row.rfqNumber, row.requisitionCode, row.vesselName, row.status]} />
    <Widget title='Quotations' count={quotationCount} rows={quotations} loading={loading} onView={onQuotations} columns={['Reference', 'Vendor', 'Amount', 'Status']} values={(row) => [String(row.id ?? '—'), row.vendor?.name, row.totalAmount != null ? `${row.currency || row.quotationCurrency || ''} ${row.totalAmount}` : '—', row.status]} />
    <Widget title='Invoices' count={invoiceCount} rows={invoices} loading={loading} onView={onInvoices} columns={['Invoice', 'PO', 'Amount', 'Status']} values={(row) => [row.invoiceNumber, row.poNumber, row.amount != null ? `${row.currency || ''} ${row.amount}` : '—', row.status]} />
  </div>
)

export default ProcurementAdditionalWidgets
